/**
 * Personal template / signature lists hold the caller's own items AND the ones
 * shared with them (#955: `GET /api/email-templates` → `templates`,
 * `GET /api/signatures` → `signatures`). These helpers split them for display.
 *
 * An item counts as shared only when both ids are known and differ, so a list
 * read without a signed-in user, or a legacy item with no `user_id`, stays in
 * "mine" exactly as before #955.
 */
export function isSharedWithMe(item, userId) {
    return !!(userId && item?.user_id && item.user_id !== userId);
}

export function splitByOwner(items, userId) {
    const mine = [];
    const shared = [];
    (items || []).forEach(item => (isSharedWithMe(item, userId) ? shared : mine).push(item));
    return { mine, shared };
}

/** Picker label for an item shared with the caller: "Name · Owner". */
export function sharedItemLabel(name, item) {
    return item?.owner_name ? `${name} · ${item.owner_name}` : name;
}
